import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import EditShipment from "./EditShipment/EditShipment";
import ShipmentItems from "./ShipmentItems/ShipmentItems";
import {
    selectShipment,
    selectShipmentDeletingError,
    selectShipmentDeletingStatus,
    selectShipmentUpdatingError,
    selectShipmentUnauthorized,
    setDeletingStatus,
    setUnauthorized,
    uploadShipment,
    selectShipmentUploadingError,
    setShipmnetDeletingError,
    setShipmentUpdatingError,
    uploadShipmentDeliveryPrices,
    selectShipmentUpdatingStatus,
    setShipmentToInitialState,
    closeShipmentDeletingPopup,
    uploadShipmentTotalPrices,
    selectShipmentUploadingStatus,
    selectShipmentSendingToAkadStatus,
    setSendingToAkadStatus,
    selectShipmentSendingToAkadError,
} from "./shipmentSlice";

import {
    uploadShipmentBoxes,
    selectShipmentBoxDeletingStatus,
    selectShipmentItemDeletingStatus,
    selectShipmentItemsCreatingStatus,
    selectShipmentItemsUpdatingStatus,
    selectShipmentBoxUpdatingStatus,
    setErrors,
    setShipmentItemsToInitialState,
    selectCreatingBoxStatus,
} from "./ShipmentItems/shipmentItemsSlice";

import Upper from "./Upper/Upper";

import {
    setPathToShipments,
} from "../path/pathSlice";

import { pushAlert } from "../alerts/alertSlice";
import { requireAuthentication } from "../authentication/authSlice";
import { selectAllShipmentItemsErrors } from "./ShipmentItems/shipmentItemsSlice";
import { useTranslation } from "react-i18next";
import GreenSpinner from "../../components/loaders/GreenSpinner";
import AdditionalFiles from "./AdditionalFiles/AdditionalFiles";
import SendToAkadButton from "./sendToAkad/SendToAkadButton";
import AfterSendingSubscription from "./sendToAkad/AfterSendingSubscription";

const ShipmentPage = () => {
    const {t} = useTranslation()
    let params = useParams();

    const dispatch = useDispatch();
    let shipment = useSelector(selectShipment);
    
    const uploadingError = useSelector(selectShipmentUploadingError);
    const uploadingStatus = useSelector(selectShipmentUploadingStatus)

    const deletingStatus = useSelector(selectShipmentDeletingStatus);
    const updatingStatus = useSelector(selectShipmentUpdatingStatus);

    const itemsCreatingStatus = useSelector(selectShipmentItemsCreatingStatus);
    const itemsUpdatingStatus = useSelector(selectShipmentItemsUpdatingStatus);
    const itemsDeletingStatus = useSelector(selectShipmentItemDeletingStatus);
    const boxesCreatingStatus = useSelector(selectCreatingBoxStatus);
    const boxesUpdatingStatus = useSelector(selectShipmentBoxUpdatingStatus);
    const boxesDeletingStatus = useSelector(selectShipmentBoxDeletingStatus);

    const shipmentDeletingError = useSelector(selectShipmentDeletingError);
    const shipmentUpdatingError = useSelector(selectShipmentUpdatingError);
    
    const shipmentItemsErrors = useSelector(selectAllShipmentItemsErrors);

    const sendingToAkadSatatus = useSelector(selectShipmentSendingToAkadStatus)
    const sendingToAkadError = useSelector(selectShipmentSendingToAkadError)

    const unauthorized = useSelector(selectShipmentUnauthorized);

    //on unmount
    useEffect(() => {
        return () => {
            dispatch(setShipmentToInitialState())
            dispatch(setShipmentItemsToInitialState())
        };
    }, [dispatch]);

    // on unauthorized
    useEffect(() => {
        if (unauthorized) {
            dispatch(requireAuthentication())
            dispatch(
                setUnauthorized({
                    unauthorized: false,
                })
            );
        }
    }, [dispatch, unauthorized]);

    // on changing shipment id
    useEffect(() => {
        dispatch(uploadShipment({ shipmentID: params.shipmentID }));
    }, [dispatch, params.shipmentID]);

    //on delete success
    useEffect(() => {
        if (deletingStatus === "fulfilled") {
            dispatch(setDeletingStatus({ status: null }));
            dispatch(setPathToShipments());
        }
    }, [deletingStatus, dispatch]);

    //on shipment update success
    useEffect(() => {
        if (updatingStatus === "fulfilled") {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: params.shipmentID }));
            dispatch(uploadShipmentTotalPrices({ shipmentID: params.shipmentID }));
            dispatch(uploadShipmentBoxes({shipmentID: params.shipmentID}))
        }
    }, [updatingStatus, dispatch, params.shipmentID]);

    //on items create status success
    useEffect(() => {
        if (itemsCreatingStatus === "fulfilled") {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: params.shipmentID }));
            dispatch(uploadShipmentTotalPrices({ shipmentID: params.shipmentID }));
            dispatch(
                uploadShipmentBoxes({
                    shipmentID: params.shipmentID,
                })
            );
        }
    }, [itemsCreatingStatus, dispatch, params.shipmentID]);

    //on items update status success
    useEffect(() => {
        if (itemsUpdatingStatus === "fulfilled") {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: params.shipmentID }));
            dispatch(uploadShipmentTotalPrices({ shipmentID: params.shipmentID }));
            dispatch(
                uploadShipmentBoxes({
                    shipmentID: params.shipmentID,
                })
            );
        }
    }, [itemsUpdatingStatus, dispatch, params.shipmentID]);

    //on item delete
    useEffect(() => {
        if (itemsDeletingStatus === "fulfilled") {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: params.shipmentID }));
            dispatch(uploadShipmentTotalPrices({ shipmentID: params.shipmentID }));
            dispatch(
                uploadShipmentBoxes({
                    shipmentID: params.shipmentID,
                })
            );
        }
    }, [itemsDeletingStatus, dispatch, params.shipmentID]);

    //on box create status success
    useEffect(() => {
        if (boxesCreatingStatus === "fulfilled") {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: params.shipmentID }));
        }
    }, [boxesCreatingStatus, dispatch, params.shipmentID]);

    //on boxes update status success
    useEffect(() => {
        if (boxesUpdatingStatus === "fulfilled") {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: params.shipmentID }));
            dispatch(uploadShipmentTotalPrices({ shipmentID: params.shipmentID }));
        }
    }, [boxesUpdatingStatus, dispatch, params.shipmentID]);

    //on box delete
    useEffect(() => {
        if (boxesDeletingStatus === "fulfilled") {
            dispatch(uploadShipmentDeliveryPrices({ shipmentID: params.shipmentID }));
            dispatch(uploadShipmentTotalPrices({ shipmentID: params.shipmentID }));
        }
    }, [boxesDeletingStatus, dispatch, params.shipmentID]);

    //on sending to akad
    useEffect(() => {
        if(sendingToAkadSatatus === "fulfilled") {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' } )
            dispatch(setSendingToAkadStatus(null))
        }
    }, [dispatch, sendingToAkadSatatus])




    //on shipment deleting error
    useEffect(() => {
        if (shipmentDeletingError) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentDeletingError),
                delay: 2000,
            }))
            dispatch(setShipmnetDeletingError(null))
            dispatch(closeShipmentDeletingPopup())
        }
    }, [shipmentDeletingError, dispatch, shipmentItemsErrors]);

    //on shipment updating error
    useEffect(() => {
        if (shipmentUpdatingError) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentUpdatingError),
                delay: 2000,
            }))
        }
        dispatch(setShipmentUpdatingError(null))
    }, [shipmentUpdatingError, dispatch, shipmentItemsErrors]);

    //on items creating error
    useEffect(() => {
        if (shipmentItemsErrors.creating) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentItemsErrors.creating),
                delay: 2000,
            }))
            dispatch(setErrors({...shipmentItemsErrors, creating: null}))
        }
    }, [shipmentItemsErrors.creating, dispatch, shipmentItemsErrors]);

    //on items updating error
    useEffect(() => {
        if (shipmentItemsErrors.updating) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentItemsErrors.updating),
                delay: 2000,
            }))
        }
    }, [shipmentItemsErrors.updating, dispatch]);

    //on items deleting error
    useEffect(() => {
        if (shipmentItemsErrors.deletingItem) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentItemsErrors.deletingItem),
                delay: 2000,
            }))
            dispatch(setErrors({...shipmentItemsErrors, deletingItem: null}))
        }
    }, [shipmentItemsErrors.deletingItem, dispatch, shipmentItemsErrors]);

    //on boxes creating error
    useEffect(() => {
        if (shipmentItemsErrors.creatingBox) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentItemsErrors.creatingBox),
                delay: 2000,
            }))
            dispatch(setErrors({...shipmentItemsErrors, creatingBox: null}))
        }
    }, [shipmentItemsErrors.creatingBox, dispatch, shipmentItemsErrors]);

    //on boxes updating error
    useEffect(() => {
        if (shipmentItemsErrors.updatingBox) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentItemsErrors.updatingBox),
                delay: 2000,
            }))
            dispatch(setErrors({...shipmentItemsErrors, updatingBox: null}))
        }
    }, [shipmentItemsErrors.updatingBox, dispatch, shipmentItemsErrors]);

    //on boxes deleting error
    useEffect(() => {
        if (shipmentItemsErrors.deletingBox) {
            dispatch(pushAlert({
                type: "danger",
                message: t(shipmentItemsErrors.deletingBox),
                delay: 2000,
            }))
            dispatch(setErrors({...shipmentItemsErrors, deletingBox: null}))
        }
    }, [shipmentItemsErrors.deletingBox, dispatch, shipmentItemsErrors]);

    //on sending to akad error
    useEffect(() => {
        if (sendingToAkadError) {
            dispatch(pushAlert({
                type: "danger",
                message: t(sendingToAkadError),
                delay: 2000,
            }))
        }
    }, [sendingToAkadError, dispatch, shipmentItemsErrors]);

    useEffect(() => { 
        if(shipment?.blocked) {
            dispatch(pushAlert({
                type: "warning",
                message: t("shipment.info.package_sent_to_akad"),
                delay: 5000,
            }))
        }
    }, [dispatch, shipment?.blocked, t])

    return (
        <>
            {uploadingStatus === "pending" && <GreenSpinner />}
            {uploadingError === "forbidden" && <>Forbidden</>}
            {uploadingError === "shipment not found" && (
                <>Not found :(</>
            )}
            {shipment && (
                <>
                    {
                        shipment["bill-id"] &&
                        <NavLink
                            to={`/shipment-bills#${shipment["trc"]}`}
                        >
                            <div className="flex items-center bg-blue-500 text-white text-xs font-bold px-4 py-3" role="alert">
                                <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
                                <p>
                                    {t("shipment.bill")}: {"  "} 
                                        {shipment["trc"]}
                                </p>
                            </div>
                        </NavLink>
                    }
                    <div className="w-full px-3 xs:px-6 py-4 pb-5 border my-3 shadow-2xl  rounded-xl">
                        <Upper trc={shipment.trc} id={shipment.id} />
                        <EditShipment />
                        <AdditionalFiles />
                        <ShipmentItems packageType={shipment["package-type"] ?? ""}/>
                        {
                            shipment.blocked ?
                            <AfterSendingSubscription /> :
                            <SendToAkadButton />
                        }
                    </div>
                </>
            )}
        </>
    );
};

export default ShipmentPage;
